<!-- Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. -->

<div *ngTemplateOutlet="customContent"></div>

<mat-divider class="padded-divider"></mat-divider>

<button-footer
	mat-dialog-actions
	[saveOrCloseButtonText]="'Back'"
	(buttonSaveOrClose)="onCloseClick()"
></button-footer>
